import { DynamicLayout, formBuilderConstants } from '../../formbuilder';
import { newStepValue } from '../../../../services/flowBuilder/utils/constants';

export const chatHub = {
    json: {
        action: {
            name: '',
            description: '',
            actionType: 'chatHub',
            actionParams: {
                chatHub: {
                    imageUrl: '',
                    providerId: '',
                    instanceId: '',
                    apiId: '',
                    // parameters:
                    //     - "id":
                    //     value: "Bloo"
                    //     type: "string"
                    //     - "var":
                    //     value: "[[Bloo]]"
                    //     type: "string | number | boolean | list"
                },
            },
            result: {
                success: newStepValue,
                error: newStepValue,
            },
        },
        type: 'action',
    },
    paths: [
        'action.name',
        'action.description',
        'action.actionParams.chatHub.imageUrl',
        'action.actionParams.chatHub.providerId',
        'action.actionParams.chatHub.instanceId',
        'action.actionParams.chatHub.apiId',
        'action.result.#',
    ],
    groups: [
        {
            Parameters: [
                'action.name',
                'action.description',
                'action.actionParams.chatHub.imageUrl',
                'action.actionParams.chatHub.providerId',
                'action.actionParams.chatHub.instanceId',
                'action.actionParams.chatHub.apiId',
            ],
        },
        {
            Logic: ['action.result.#'],
        },
    ],
    layout: {
        name: {
            type: 'text',
            label: 'Name',
            validators: {
                required: true,
                spaceOnName: true,
            },
        },
        description: {
            type: 'text',
            label: 'Description',
            validators: {
                required: true,
            },
        },
        imageUrl: {
            type: 'text',
            label: 'Image URL',
            validators: {
                required: true,
            },
        },
        providerId: {
            type: 'text',
            label: 'Provider ID',
            validators: {
                required: true,
            },
        },
        instanceId: {
            type: 'text',
            label: 'Instance ID',
            validators: {
                required: true,
            },
        },
        apiId: {
            type: 'text',
            label: 'API ID',
            validators: {
                required: true,
            },
        },
        result: {
            dataType: 'keyValue',
            key: {
                attributes: {
                    readonly: true,
                },
                type: 'text',
                label: '#',
            },
            value: {
                attributes: {
                    // readonly: false
                },
                type: 'next',
                label: 'Point to',
            },
        },
    },
};
